module.exports = __webpack_public_path__ + "8342df9ebb2f4dc9ee0432cbbbee7a38.svg";